<template>
  <div>
    <BaseSelect
      v-model="target[type]"
      placeholder="Søg"
      tag-position="bottom"
      :options="getAllSubstances"
      track-by="name"
      label="name"
      :multiple="false"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import BaseSelect from '../../../components/BaseSelect.vue';

export default {
    name: 'TargetSubstance',
    components: { BaseSelect },
    props: {
        target: { type: Object, required: true },
        type: { type: String, required: true },
    },
    computed: {
        ...mapGetters('substances', [
            'getAllSubstances',
        ]),
    },
    methods: {
        ...mapActions('substances', [
            'loadSubstances',
        ]),
    },
    async created() {
        try {
            await this.loadSubstances();
        } catch (error) {
            //
        }
    },
};
</script>
